export enum DocumentTypeEnum {
	TYPE_DIVERS = 'TYPE_DIVERS',
	TYPE_CNI = 'TYPE_CNI',
	TYPE_ATTESTATION_DOMICILE = 'TYPE_ATTESTATION_DOMICILE',
	TYPE_KBIS = 'TYPE_KBIS',
	TYPE_DOCUMENT_EMETTEUR = 'TYPE_DOCUMENT_EMETTEUR',
	TYPE_DOCUMENT_GESTIONNAIRE_PROJET = 'TYPE_DOCUMENT_GESTIONNAIRE_PROJET',
	TYPE_DOCUMENT_SOCIETE = 'TYPE_DOCUMENT_SOCIETE',
	TYPE_DOCUMENT_COMMUN_OPERATION = 'TYPE_DOCUMENT_COMMUN_OPERATION',
	TYPE_DOCUMENT_PLATEFORME = 'TYPE_DOCUMENT_PLATEFORME',
	TYPE_DOSSIER_SIGNE = 'TYPE_DOSSIER_SIGNE',
	TYPE_BULLETIN_SOUCRIPTION = 'TYPE_BULLETIN_SOUCRIPTION',
	TYPE_DOCUMENT_ASSEMBLEE = 'TYPE_DOCUMENT_ASSEMBLEE',
	TYPE_DOCUMENT_ASSEMBLEE_PARTICIPATION = 'TYPE_DOCUMENT_ASSEMBLEE_PARTICIPATION',
	TYPE_STATUTS = 'TYPE_STATUTS',
	TYPE_CNI_SUP = 'TYPE_CNI_SUP',
	TYPE_RECAP_KYC = 'TYPE_RECAP_KYC',
	TYPE_DOC_A_SIGNER = 'TYPE_DOC_A_SIGNER',
	TYPE_ATTESTATION_SOUSCRIPTION = 'TYPE_ATTESTATION_SOUSCRIPTION',
	TYPE_ATTESTATION_DISSOLUTION = 'TYPE_ATTESTATION_DISSOLUTION',
	TYPE_DOCUMENT_TRANCHE = 'TYPE_DOCUMENT_TRANCHE',
	TYPE_DOCUMENT_TRANCHE_PVOBLIGATION = 'TYPE_DOCUMENT_TRANCHE_PVOBLIGATION',
	TYPE_DOCUMENT_TRANCHE_PV_OUVERTURE_CAPITAL = 'TYPE_DOCUMENT_TRANCHE_PV_OUVERTURE_CAPITAL',
	TYPE_CGV_CIBLE = 'TYPE_CGV_CIBLE',
	TYPE_LOI_CIBLE = 'TYPE_LOI_CIBLE',
	TYPE_CP_CIBLE = 'TYPE_CP_CIBLE',
	TYPE_ELIGIBILITE_DEFISC_CIBLE = 'TYPE_ELIGIBILITE_DEFISC_CIBLE',
	TYPE_SORTIE_VALIDATION_INFOS = 'TYPE_SORTIE_VALIDATION_INFOS',
	TYPE_CONFIRMATION_VIREMENT = 'TYPE_CONFIRMATION_VIREMENT',
	TYPE_DISPENSE_PRELEVEMENT_LIB = 'TYPE_DISPENSE_PRELEVEMENT_LIB',
	TYPE_JUSTIFICATIF_SITUATION_FISCALE_PARTICULIERE = 'TYPE_JUSTIFICATIF_SITUATION_FISCALE_PARTICULIERE',
	TYPE_ATTESTATION_FISC_PERS_PHYS = 'TYPE_ATTESTATION_FISC_PERS_PHYS',
	TYPE_ATTESTATION_FISC_PERS_MORALE = 'TYPE_ATTESTATION_FISC_PERS_MORALE',
	TYPE_RIB_SCANNE = 'TYPE_RIB_SCANNE',
	TYPE_IMMO_CONTRAT_INTERVENTION = 'TYPE_IMMO_CONTRAT_INTERVENTION',
	TYPE_IMMO_GAPD = 'TYPE_IMMO_GAPD',
	TYPE_IMMO_LOI = 'TYPE_IMMO_LOI',
	TYPE_FACTURE_EMETTEUR = 'TYPE_FACTURE_EMETTEUR',
	TYPE_INTERNE_EXPORT_TRACK = 'TYPE_INTERNE_EXPORT_TRACK',
	TYPE_CONTRACTUEL_OPERATION = 'TYPE_CONTRACTUEL_OPERATION',
	TYPE_AVATAR = 'TYPE_AVATAR',
	TYPE_MEDIATHEQUE = 'TYPE_MEDIATHEQUE',
	TYPE_LOGO = 'TYPE_LOGO',
	TYPE_IMAGE_EQUIPE = 'TYPE_IMAGE_EQUIPE',
	TYPE_GALLERIE = 'TYPE_GALLERIE',
	TYPE_MEMBRE_PHOTO = 'TYPE_MEMBRE_PHOTO',
	TYPE_MEMBRE_CV = 'TYPE_MEMBRE_CV',
	TYPE_CIBLE_TEASER = 'TYPE_CIBLE_TEASER',
	TYPE_CIBLE_BP = 'TYPE_CIBLE_BP',
	TYPE_CIBLE_EXEC_SUM = 'TYPE_CIBLE_EXEC_SUM',
	TYPE_CIBLE_STATUTS = 'TYPE_CIBLE_STATUTS',
	TYPE_CIBLE_PACTE = 'TYPE_CIBLE_PACTE',
	TYPE_CIBLE_DOC_SUP = 'TYPE_CIBLE_DOC_SUP',
	TYPE_EMETTEUR_DOC_SUP = 'TYPE_EMETTEUR_DOC_SUP',
	TYPE_PLATEFORME_PRESSBOOK_IMAGE = 'TYPE_PLATEFORME_PRESSBOOK_IMAGE',
	TYPE_PLATEFORME_PRESSBOOK_FICHIER = 'TYPE_PLATEFORME_PRESSBOOK_FICHIER',
	TYPE_PLATEFORME_NEWS = 'TYPE_PLATEFORME_NEWS',
	TYPE_PLATEFORME_EDITO = 'TYPE_PLATEFORME_EDITO',
	TYPE_CIBLE_PRESSBOOK_IMAGE = 'TYPE_CIBLE_PRESSBOOK_IMAGE',
	TYPE_CIBLE_PRESSBOOK_FICHIER = 'TYPE_CIBLE_PRESSBOOK_FICHIER',
	TYPE_CIBLE_DOCUMENT_DD = 'TYPE_CIBLE_DOCUMENT_DD',
	TYPE_PLATEFORME_MODELE_ODT = 'TYPE_PLATEFORME_MODELE_ODT',
	TYPE_EMETTEUR_MODELE_ODT = 'TYPE_EMETTEUR_MODELE_ODT',
	TYPE_LETTRE_DE_MISSION = 'TYPE_LETTRE_DE_MISSION',
	TYPE_LOGO_PARTENAIRE = 'TYPE_LOGO_PARTENAIRE',
	TYPE_PRESENTATION_PUBLIQUE = 'TYPE_PRESENTATION_PUBLIQUE',
	TYPE_SIGNATURE = 'TYPE_SIGNATURE',
	TYPE_MAIL_PJ = 'TYPE_MAIL_PJ',
	TYPE_POST_CIBLE = 'TYPE_POST_CIBLE',
	TYPE_POST_PLATEFORME = 'TYPE_POST_PLATEFORME',
	TYPE_POST_EMETTEUR = 'TYPE_POST_EMETTEUR',
	TYPE_POST_GESTIONNAIRE_PROJET = 'TYPE_POST_GESTIONNAIRE_PROJET',
	TYPE_IMAGE_COVER_LARGE = 'TYPE_IMAGE_COVER_LARGE',
	TYPE_IMAGE_COVER_SMALL = 'TYPE_IMAGE_COVER_SMALL',
	TYPE_IMAGE_CARD_LARGE = 'TYPE_IMAGE_CARD_LARGE',
	TYPE_IMAGE_CARD_SMALL = 'TYPE_IMAGE_CARD_SMALL',
	TYPE_IMAGE_DESCRIPTION = 'TYPE_IMAGE_DESCRIPTION',
	TYPE_PROMOTEUR_LOGO = 'TYPE_PROMOTEUR_LOGO',
	TYPE_PROMOTEUR_IMAGE_COVER_LARGE = 'TYPE_PROMOTEUR_IMAGE_COVER_LARGE',
	TYPE_PROMOTEUR_IMAGE_COVER_SMALL = 'TYPE_PROMOTEUR_IMAGE_COVER_SMALL',
	TYPE_PRODUCTEUR_ENERGIE_LOGO = 'TYPE_PRODUCTEUR_ENERGIE_LOGO',
	TYPE_PRODUCTEUR_ENERGIE_IMAGE_COVER_LARGE = 'TYPE_PRODUCTEUR_ENERGIE_IMAGE_COVER_LARGE',
	TYPE_PRODUCTEUR_ENERGIE_IMAGE_COVER_SMALL = 'TYPE_PRODUCTEUR_ENERGIE_IMAGE_COVER_SMALL',
	TYPE_AGROFORESTIER_LOGO = 'TYPE_AGROFORESTIER_LOGO',
	TYPE_AGROFORESTIER_IMAGE_COVER_LARGE = 'TYPE_AGROFORESTIER_IMAGE_COVER_LARGE',
	TYPE_AGROFORESTIER_IMAGE_COVER_SMALL = 'TYPE_AGROFORESTIER_IMAGE_COVER_SMALL',
	TYPE_DIRIGEANT_LOGO = 'TYPE_DIRIGEANT_LOGO',
	TYPE_DIRIGEANT_IMAGE_COVER_LARGE = 'TYPE_DIRIGEANT_IMAGE_COVER_LARGE',
	TYPE_DIRIGEANT_IMAGE_COVER_SMALL = 'TYPE_DIRIGEANT_IMAGE_COVER_SMALL',
	TYPE_DOC_CIBLE_AUDIT = 'TYPE_DOC_CIBLE_AUDIT',
	TYPE_DOC_CIBLE_REPORTING_DOC_SUP = 'TYPE_DOC_CIBLE_REPORTING_DOC_SUP',
	TYPE_DOC_CIBLE_REPORTING = 'TYPE_DOC_CIBLE_REPORTING',
	TYPE_AVATAR_CIBLE_EXPERT = 'TYPE_AVATAR_CIBLE_EXPERT',
	TYPE_CIBLE_DOC_DIR = 'TYPE_CIBLE_DOC_DIR',
	TYPE_COMMUNIQUE_PRESSE = 'TYPE_COMMUNIQUE_PRESSE',
	TYPE_GUIDES = 'TYPE_GUIDES',
	TYPE_ATTESTATION_DEPOT_FONDS = 'TYPE_ATTESTATION_DEPOT_FONDS',
	TYPE_DOC_DIRS = 'TYPE_DOC_DIRS',
	TYPE_DOC_PREMIER_CONTACT_IMMO = 'TYPE_DOC_PREMIER_CONTACT_IMMO',
	TYPE_LIASSE_IFU = 'TYPE_LIASSE_IFU',
	TYPE_SOCIETE_LOGO = 'TYPE_SOCIETE_LOGO',
	FORMULAIRE_5000 = 'FORMULAIRE_5000',
	TYPE_PJ_SONDAGE_GPC = 'TYPE_PJ_SONDAGE_GPC',
	TYPE_IBAN_PEA = 'TYPE_IBAN_PEA',
	TYPE_ATTESTATION_VIREMENT = 'TYPE_ATTESTATION_VIREMENT',
	TYPE_INDICATEURS_PERFORMANCE = 'TYPE_INDICATEURS_PERFORMANCE',
	TYPE_PROCURATION_OCA = 'TYPE_PROCURATION_OCA'
}
